<template>
  <b-form-group
    :id="idGroup"
    v-model="modelValue"
    :label="label"
    :label-align="labelAlign"
    :label-align-sm="labelAlignSm"
    :label-align-md="labelAlignMd"
    :label-align-lg="labelAlignLg"
    :label-align-xl="labelAlignXl"
    :label-cols="labelCols"
    :label-cols-lg="labelColsLg"
    :label-cols-md="labelColsMd"
    :label-cols-sm="labelColsSm"
    :label-cols-xl="labelColsXl"
    :label-for="labelFor"
    :class="formGroupClass"
    class="form"
  >
    <!-- <pre>{{ modelValue }}</pre> -->
    <div class="p-inputgroup">
      <input-number
        v-model="inputValue"
        mode="decimal"
        :locale="locale"
        :step="step"
        :min="min"
        :max="max"
        :min-fraction-digits="minFractionDigits"
        :max-fraction-digits="maxFractionDigits"
        :disabled="disabled"
        :class="{ 'has-element': hasElementToAppend, 'is-invalid': error }"
        class="custom-input-number"
        input-class="custom-input-padding"
        @input="handleInput"
        @keyup="handleKeyUp"
      />
      <span v-if="hasElementToAppend" class="p-inputgroup-addon custom-input-padding" :class="inputGroupTextclass">
        <currency-svg
          v-if="+elementAppendChoice === ELEMENT_APPEND_CHOICE.CURRENCY"
          :color="currencyColor"
          :opacity="currencyOpacity"
          :width="currencyWidth"
          :height="currencyHeight"
        />
        <component
          :is="getLucideIcon(lucideName)"
          v-if="+elementAppendChoice === ELEMENT_APPEND_CHOICE.LUCIDE"
          :color="lucideColor"
          :size="lucideSize"
          :class="lucideClass"
          :stroke-width="lucideStrokeWidth"
        />
        <b-icon v-if="+elementAppendChoice === ELEMENT_APPEND_CHOICE.FONT_AWESOME" :icon="fontAwesomeIconName" :class="fontAwesomeIconClass" />
        <div v-if="+elementAppendChoice === ELEMENT_APPEND_CHOICE.TEXT" class="font-weight-bold" :class="textClass">
          {{ inputGroupText }}<sub v-if="isSub">{{ subValue }}</sub>
          <sup v-if="isSup">{{ supValue }}</sup>
        </div>
      </span>
    </div>
    <div v-if="error" class="invalid-feedback">
      {{ errorLabel }}
    </div>
  </b-form-group>
</template>
<script>
import LanguageMessages from '@/mixins/languageMessages';
import InputNumber from 'primevue/inputnumber';
import CurrencySvg from '@/components/Svg/Currency';
import _ from 'lodash';
import { ELEMENT_APPEND_CHOICE } from '@/shared/constants';
import { store } from '@/store';
import GlobalMixin from '@/mixins/global.mixin';
import { isNotNull } from '@/shared/utils';

export default {
  name: 'TgsInputNumber',
  components: {
    InputNumber,
    CurrencySvg
  },
  mixins: [LanguageMessages, GlobalMixin],
  props: {
    value: {
      type: Number,
      required: false,
      default: 0
    },
    idGroup: {
      type: String,
      required: false,
      default: ''
    },
    idInput: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    labelAlign: {
      type: String,
      required: false,
      default: ''
    },
    labelAlignSm: {
      type: String,
      required: false,
      default: ''
    },
    labelAlignMd: {
      type: String,
      required: false,
      default: ''
    },
    labelAlignLg: {
      type: String,
      required: false,
      default: ''
    },
    labelAlignXl: {
      type: String,
      required: false,
      default: ''
    },
    labelCols: {
      type: [Boolean, Number, String],
      required: false,
      default: 12
    },
    labelColsLg: {
      type: [Boolean, Number, String],
      required: false,
      default: 12
    },
    labelColsMd: {
      type: [Boolean, Number, String],
      required: false,
      default: 12
    },
    labelColsSm: {
      type: [Boolean, Number, String],
      required: false,
      default: 12
    },
    labelColsXl: {
      type: [Boolean, Number, String],
      required: false,
      default: 12
    },
    labelFor: {
      type: String,
      required: false,
      default: ''
    },
    formGroupClass: {
      type: String,
      required: false,
      default: ''
    },
    inputGroupTextclass: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    step: {
      type: Number,
      required: false,
      default: 1
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    currencyColor: {
      type: String,
      required: false,
      default: '#06263E'
    },
    currencyOpacity: {
      type: Number,
      required: false,
      default: 0.85
    },
    currencyWidth: {
      type: Number,
      required: false,
      default: 15
    },
    currencyHeight: {
      type: Number,
      required: false,
      default: 15
    },
    lucideName: {
      type: String,
      required: false,
      default: ''
    },
    lucideColor: {
      type: String,
      required: false,
      default: '#000000'
    },
    lucideSize: {
      type: Number,
      required: false,
      default: 16
    },
    lucideClass: {
      type: String,
      required: false,
      default: ''
    },
    lucideStrokeWidth: {
      type: Number,
      required: false,
      default: 2
    },
    textClass: {
      type: String,
      required: false,
      default: ''
    },
    inputGroupText: {
      type: String,
      required: false,
      default: ''
    },
    subValue: {
      type: String,
      required: false,
      default: ''
    },
    supValue: {
      type: String,
      required: false,
      default: ''
    },
    fontAwesomeIconName: {
      type: String,
      required: false,
      default: ''
    },
    fontAwesomeIconClass: {
      type: String,
      required: false,
      default: ''
    },
    elementAppendChoice: {
      type: [Number, String],
      required: false,
      default: ''
    },
    hasElementToAppend: {
      type: Boolean,
      required: false,
      default: false
    },
    minFractionDigits: {
      type: Number,
      required: false,
      default: 0
    },
    maxFractionDigits: {
      type: Number,
      required: false,
      default: 0
    },
    modelName: {
      type: String,
      required: true,
      default: null
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    errorLabel: {
      type: String,
      required: false,
      default: 'Please, value must be greater than 0'
    },
    formatter: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      ELEMENT_APPEND_CHOICE,
      inputValue: 0,
      excludeLocale: ['sub-e'],
      locale: 'fr-BE'
    };
  },
  computed: {
    isSub() {
      return !_.isUndefined(this.subValue) && !_.isEmpty(this.subValue) && !_.isNil(this.subValue);
    },
    isSup() {
      return !_.isUndefined(this.supValue) && !_.isEmpty(this.supValue) && !_.isNil(this.supValue);
    },
    regionalSetting() {
      return this.getProjectConfigProperty('regionalSetting', 0);
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        return value;
      }
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (isNotNull(newValue) && newValue !== oldValue) this.inputValue = newValue; // newValue !== undefined|null|''
      },
      immediate: true
    },
    inputValue: {
      handler(value) {
        this.$emit(`input-number:value`, { model: this.modelName, payload: value });
      },
      deep: true
      // immediate: true
    }
  },
  mounted() {
    this.locale = this.getRegionalSettingText(this.regionalSetting);
  },
  methods: {
    handleInput(payload) {
      // if (_.isNil(payload)) {
      // 	// console.log({ payload });
      // }
      this.$emit('change', payload);
    },
    handleKeyUp(payload) {
      if (_.isNil(this.inputValue)) {
        // console.log({ payload: this.inputValue });
        this.inputValue = 0;
      }
    },
    getRegionalSettingText(id) {
      const menus = this.FormMenu(11023);
      let text = menus.filter((menu) => menu.value === +id)[0].text;

      if (this.excludeLocale.includes(text.toLowerCase())) {
        text = 'sub';
      } else {
        text = text.split('-');
        text = text[0].toLowerCase() + '-' + text[1];
      }

      return text.split('(')[0]; // catch and handle translation info when shown. ex 'fr-Fr(11023, 2)'
    }
  }
};
</script>
<style lang="scss">
.custom-input-number {
  font-family: Archivo, sans-serif !important;

  .p-inputtext {
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.02em;
    color: rgba(6, 38, 62, 0.64);
    border-radius: 8px !important;
  }

  .p-inputtext:enabled:focus {
    border-color: #ced4da !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 160, 156, 0.25);
  }

  .p-inputtext:hover {
    border-color: #ced4da !important;
  }

  &.has-element > .p-inputtext {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  &.is-invalid > .p-inputtext {
    border-color: #ea4e2c;
  }

  &.is-invalid > .p-inputtext:enabled:focus {
    box-shadow: 0 0 0 0.2rem rgba(234, 78, 44, 0.25);
  }
}

.custom-input-padding {
  padding: 0.375rem 0.75rem !important;
  min-width: 0 !important;
}
</style>
